const whatsappNumber = "553182668345";
const mensagem = 'Olá! Gostaria de saber mais informações sobre "Ofertas Especiais Para Grupos" Vida&Piedade';

const  WhatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(mensagem)}`;

export default WhatsappLink;